import { getInitialStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-initial-structure-nodeset";
import { getMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";

export class TransferSelectedNodesToMachineStructureHandler {
  transferSelectedNodesToMachineStructure() {
    const initialStructureNodeset = getInitialStructureNodeset();
    const machineStructureNodeset = getMachineStructureNodeset();

    machineStructureNodeset.transferSelectedNodesToRootNode(
      initialStructureNodeset,
      machineStructureNodeset,
    );
  }
}
